<ng-content></ng-content>
<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
<div
	class="open-close-eye text-muted"
	[style.width.px]="ICON_CONTAINER_WIDTH"
	[style.height.px]="ICON_CONTAINER_HEIGHT"
	(click)="toggleVisibility()"
	[style.bottom.px]="(element.scrollHeight - ICON_CONTAINER_HEIGHT) / 2"
>
	<!-- Eye Icon -->
	<ng-fa-icon
		[icon]="passwordVisibility ? 'eye-slash' : 'eye'"
		[fixedWidth]="false"
		[ngTooltip]="passwordVisibility ? 'Hide ' + inputName : 'Show ' + inputName"
		container="body"
	></ng-fa-icon>
</div>
